var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.disabled)?[_vm._v(" "+_vm._s(_vm.data)+" ")]:_c('a-range-picker',{attrs:{"size":"large","disabled":_vm.disabled,"show-time":{
      hideDisabledOptions: true,
      defaultValue: [
        _vm.moment('00:00:00', 'HH:mm:ss'),
        _vm.moment('23:59:59', 'HH:mm:ss') ],
    },"format":"DD MMM YYYY HH:mm:ss","disabled-date":_vm.disabledDate},on:{"change":_vm.dateChange},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }